import { getSessionStorage } from '@src/utils/enhancedSessionStorage'
import uniqueIdGenerator from '@src/utils/uniqueIdGenerator'

export type CheckoutFlow =
  | 'Normal checkout method'
  | 'Express Checkout Method'
  | 'Checkout From Cart'
  | 'Checkout from PDP'

export const PAYMENT_ATTEMPT_STORAGE_KEY = 'quince:payment_attempt'
export interface PaymentAttempt {
  token: string
  flow: CheckoutFlow
  payment_method: string
  payment_gateway?: string
}

// Token is a session-wide identifier shared across locales/pages, so we always
// store with `isGlobal: true` to opt out of the helper's locale-prefix scheme.
const STORAGE_OPTS = { isGlobal: true } as const

export const setPaymentAttempt = (attempt: Omit<PaymentAttempt, 'token'>): PaymentAttempt => {
  const next: PaymentAttempt = { token: uniqueIdGenerator(), ...attempt }
  getSessionStorage().setItemJSON(PAYMENT_ATTEMPT_STORAGE_KEY, next, STORAGE_OPTS)
  return next
}

export const getPaymentAttempt = (): PaymentAttempt | undefined =>
  getSessionStorage().getItemJSON<PaymentAttempt>(PAYMENT_ATTEMPT_STORAGE_KEY, STORAGE_OPTS) ?? undefined

export const updatePaymentAttempt = (patch: Partial<Omit<PaymentAttempt, 'token'>>): PaymentAttempt | undefined => {
  const current = getPaymentAttempt()
  if (!current) return undefined
  const next: PaymentAttempt = { ...current, ...patch }
  getSessionStorage().setItemJSON(PAYMENT_ATTEMPT_STORAGE_KEY, next, STORAGE_OPTS)
  return next
}

export const clearPaymentAttempt = () => {
  getSessionStorage().removeItem(PAYMENT_ATTEMPT_STORAGE_KEY, STORAGE_OPTS)
}
